export const TYPE_PHOTO_ID = {
  FRONT: 4,
  BACK: 5,
  SELFIE: 6,
  VIDEO: 8,
};

export const UPLOADED_PHOTO_STATUSES = Object.freeze({
  EMPTY: 'empty',
  APPROVED: 'approved',
  NOT_APPROVED: 'not_approved',
});

export const CAMERA_MODE_PROP = {
  USER: 'user',
  ENVIRONMENT: 'environment',
};

export const REQUIRED_ID_DOCUMENTS = Object.freeze({
  FRONT: 'idFront',
  BACK: 'idBack',
  SELFIE: 'idSelfie',
  VIDEO: 'idVideo',
});

export const CONSTRAINTS = Object.freeze({
  audio: {
    echoCancellation: true,
    noiseSuppression: true,
  },
  video: {
    width: { min: 1280, ideal: 1920 },
    height: { min: 720, ideal: 1080 },
    facingMode: CAMERA_MODE_PROP.USER,
    frameRate: { ideal: 30 },
  },
});

export const VIDEO_MIMETYPE = 'video/mp4';
export const RECORDER_TIMEOUT_MS = 500;

export const EMPTY_DOCUMENT_UPLOAD_REASONS = Object.freeze({
  [TYPE_PHOTO_ID.FRONT]: { reason: UPLOADED_PHOTO_STATUSES.EMPTY },
  [TYPE_PHOTO_ID.BACK]: { reason: UPLOADED_PHOTO_STATUSES.EMPTY },
  [TYPE_PHOTO_ID.SELFIE]: { reason: UPLOADED_PHOTO_STATUSES.EMPTY },
});
